import { render, staticRenderFns } from "./OrderKanbanSearch.vue?vue&type=template&id=90f800e8&"
import script from "./OrderKanbanSearch.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports